// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 4665) return "static/chunks/4665.6c83e821abc53fc2.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"1786":"34e389fc676984e1","2818":"c3d174bc65231526"}[chunkId] + ".js";
};